// =============================================================================
// ESPOLIDAR WEB ADMIN - EVENTS HOOKS
// =============================================================================

import { useQuery } from '@tanstack/react-query'
import { eventsApi } from '../services/api'

export function useEvents(params?: {
  event_type?: string
  device_id?: string
  limit?: number
}) {
  return useQuery({
    queryKey: ['events', params],
    queryFn: () => eventsApi.list(params),
    refetchInterval: 10000, // Refresh ogni 10 secondi
  })
}

export function useDeviceEvents(deviceId: string, params?: {
  event_type?: string
  limit?: number
}) {
  return useQuery({
    queryKey: ['events', 'device', deviceId, params],
    queryFn: () => eventsApi.listByDevice(deviceId, params),
    enabled: !!deviceId,
  })
}

export function useEventStats(deviceId: string, days?: number) {
  return useQuery({
    queryKey: ['events', 'stats', deviceId, days],
    queryFn: () => eventsApi.getStats(deviceId, days),
    enabled: !!deviceId,
  })
}
